import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: props.width ?? props.size ?? "1em",
	height: props.height ?? props.size ?? "1em",
	viewBox: "0 0 18 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 762",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9.00558 11.1957C11.6881 11.1957 13.8627 9.02111 13.8627 6.33859C13.8627 3.65606 11.6881 1.48145 9.00558 1.48145C6.32305 1.48145 4.14844 3.65606 4.14844 6.33859C4.14844 9.02111 6.32305 11.1957 9.00558 11.1957Z",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M17.5 20C17.5 15.3054 13.6944 11.5 9.00015 11.5C4.30559 11.5 0.5 15.3057 0.5 20",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})]
	})
});
export default SvgProfile;
